// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-view[data-v-03e504df]{box-sizing:border-box;padding:0;width:-moz-fit-content;width:fit-content;cursor:pointer;color:#000;border:none;background-color:initial}.action-view[data-v-03e504df]:disabled{pointer-events:none;opacity:.65}.action-view[data-v-03e504df]:hover{opacity:.8}.action-view[data-v-03e504df]:focus{outline:none}", ""]);
// Exports
module.exports = exports;
